import { StripeCreditCardType, type StripeCustomer } from '@ctct/domain-layer';
import type { PaymentMethodsPageStore } from '@ctct/state-client-layer';

import {
  getStripePaymentLogoName,
  transformStripeCreditCardName,
} from '../../_shared/PaymentMethods/utils/transformCreditCardName';

export class StripeSavedPaymentMethodService {
  constructor(private stripeCustomer: StripeCustomer | null, private pageStore: PaymentMethodsPageStore) {}

  public api() {
    return {};
  }

  public data() {
    return {
      hasSavedPaymentMethod: () => Boolean(this.stripeCustomer?.getPaymentMethod()),

      getPaymentMethodType: () => this.stripeCustomer?.getPaymentMethod()?.getType(),

      getCreditCardName: () => {
        const brand = this.stripeCustomer?.getPaymentMethod()?.getCard()?.brand;

        if (!brand) return '';

        return transformStripeCreditCardName(brand);
      },
      getCreditCardNumberFormatted: () => {
        const { last4, brand } = this.stripeCustomer?.getPaymentMethod()?.getCard() || {};

        if (!last4) return '';

        const censoring = brand === StripeCreditCardType.AMEX ? '**** ****** *' : '**** **** **** ';

        return `${censoring}${last4}`;
      },
      getCreditCardExpirationDate: () => {
        const card = this.stripeCustomer?.getPaymentMethod()?.getCard();

        if (!card) return '';

        return `${card.expMonth.toString().padStart(2, '0')}/${card.expYear}`;
      },
      getCreditCardLogoName: () => {
        const brand = this.stripeCustomer?.getPaymentMethod()?.getCard()?.brand;

        if (!brand) return '';

        return getStripePaymentLogoName(brand);
      },
      getCreditCardType: () => this.stripeCustomer?.getPaymentMethod()?.getCard()?.brand,
    };
  }

  public handlers() {
    return {};
  }
}
